module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main with-leads-table with-leads-table-active",
    attrs: {
      "slot": "main",
      "id": "dashboard-canvas"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [_c('h1', [_vm._v("Requests "), (_vm.stats.customer) ? _c('span', [_vm._v("- " + _vm._s(_vm.stats.customer))]) : _vm._e()]), _vm._v(" "), (_vm.stats.available_campaigns) ? _c('div', {
    staticClass: "pivots-wrapper"
  }, [_c('span', {
    staticClass: "pivot label"
  }, [_vm._v("\n                Campaign:\n                      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign),
      expression: "campaign"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.campaign = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" - none - ")]), _vm._v(" "), _vm._l((_vm.stats.available_campaigns), function(c) {
    return _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-2 col-md-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Total")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.total))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-md-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("OK")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.ok))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-md-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Error")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.error))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-md-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Test")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.test))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-md-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Conversions")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm.stats.sales))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-md-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Conv. Rate")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "metrics-banner-text text-center"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.convRate)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.campaign) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Stats by Campaign")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 chart-wrapper"
  }, [_c('ls-chart', {
    attrs: {
      "target-css-classes": "chart",
      "target-id": 'by_campaign',
      "bc-data": _vm.stats.chart_by_campaign.series,
      "bc-layout": _vm.stats.chart_by_campaign.layout
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (!_vm.campaign) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('h3', [_vm._v("Count by Campaign")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ls-stats-table', {
    attrs: {
      "table-data": _vm.stats.count_by_campaign,
      "table-layout": _vm.by_campaign_layout
    }
  })], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('requests-table', {
    attrs: {
      "campaign": _vm.campaign,
      "customer": _vm.customer,
      "datesRange": _vm.datesRange
    },
    on: {
      "loaded": _vm.refreshStats
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-046470e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/Requests.vue
// module id = 602
// module chunks = 0